export const US_ZIP_CODE_REGEX: RegExp = /^\d{5}(?:[-\s]\d{4})?$/;

export const US_ZIP_REGEX: RegExp = /^(\d{5})(?:[-\s](\d{4}))?$/;

export const US_ZIP_STANDARD_REGEX: RegExp = /^\d{5}$/;

export const US_MOBILE_REGEX: RegExp = /^((\+1|1)\s?)?((\(\d{3}\))|\d{3})[- ]?\d{3}-?\d{4}$/;

export const PASSWORD_REGEX: RegExp =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_\-+=[\]{};:'",.<>?/|\\`~])[A-Za-z\d!@#$%^&*()_\-+=[\]{};:'",.<>?/|\\`~]*$/;

export const LATITUDE_LONGITUDE_REGEX: RegExp =
  /^([+-]?(?:90(?:\.0+)?|[1-8]?\d(?:\.\d+)?)),\s*([+-]?(?:180(?:\.0+)?|1[0-7]\d(?:\.\d+)?|[1-9]?\d(?:\.\d+)?))$/;

export const URL_PATTERN_REGEX = new RegExp('^(?:[a-z]+:)?//', 'i');

export const CELL_PHONE_NUMBER_E164_FORMAT_REGEX: RegExp = /^\+[1-9][0-9]{0,1}\d{10,14}$/;

export const EMAIL_REGEX = /^(?!\.)(?!.*\.\.)([A-Z0-9_+-.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9-]*\.)+[A-Z]{2,}$/i; 